import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import axios from 'axios';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';

const Forgot = () => {

    const messageState = useSelector(state => state.message);  //get data from redux store
    const [email, setEmail] = useState('');  //local hooks
    const [captcha, setCaptcha] = useState('');  //local hooks
    const dispatch = useDispatch();  //Assign useDispatch so we can use it...

    const dataPost = {
        email: email
    }

    useEffect(() => {
        dispatch({ type: 'SYSMESSAGE', message: '' });
        loadCaptchaEnginge(8);
    }, [dispatch]);

    const submitRegister = () => {

        //only submit when Captcha is true
        if (validateCaptcha(captcha, false)===true) {
            axios.post('/person/forgot', dataPost)
            .then(res => {
                //dispatch({ type: 'SYSMESSAGE', message: 'User Reset Password Request Sent...', messageType: 'alert alert-success' });  //Set successful message...
                console.log('*** forgot Pass res: ', res.data);
                dispatch({ type: 'SYSMESSAGE', message: res.data, messageType: 'alert alert-success' });  //Set successful message...
            }).catch(err => {
                console.log('Error in Reset User Password: ', err.response);
                //dispatch(sysmessage(err.response.data.message)); //set error message to redux state sysmessage...
                dispatch({ type: 'SYSMESSAGE', message: err.response.data.message, messageType: 'alert alert-danger' });
            });
        }
        else {
            dispatch({ type: 'SYSMESSAGE', message: 'Captcha does not match', messageType: 'alert alert-danger' });
        }
    }

    let printMessage = '';
    if(messageState.message){
        printMessage = (
            <div className={messageState.messageType} role="alert">
                {messageState.message}
            </div>
        )
    }
    
    return(
        <>
            <div className="container" style={{ marginTop: 50 }}>
            <div className="form-product-create">
                    <h3>Forgot Password</h3>
                    {printMessage}

                    <div className="form-floating">
                        <input type="email" className="form-control" placeholder="Your - Email" 
                            onChange={event => setEmail(event.target.value)} />
                        <label>Email</label>
                    </div>
                    <br />

                    <div style={{ display: 'flex', justifyContent:'center', alignItems:'center', width: 620, padding: 10, border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                        < LoadCanvasTemplate reloadColor="red" />

                        <div className="form-floating">
                        <input style={{ width:190 }} type="captcha" className="form-control" placeholder="Enter Captcha" 
                            onChange={event => setCaptcha(event.target.value)} />
                        <label>Captcha</label>
                    </div>
                    </div>
                    <button style={{ marginTop: 20 }} className="btn btn-primary" onClick={() => submitRegister()}>Submit Reset Request</button>
            </div>
            </div>
        </>
    )
}
export default Forgot;
